export function base64ToBlob(base64) {
    const byteCharacters = atob(base64.split(',')[1]);
    const byteNumbers = new Array(byteCharacters.length);
    byteCharacters.split('').forEach((char, i) => {
        byteNumbers[i] = char.charCodeAt(0);
    });
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: 'image/png' });
}